import { Injectable, inject } from '@angular/core';
import {
  collection,
  CollectionReference,
  query,
  orderBy,
  doc,
  updateDoc,
  Timestamp,
} from 'firebase/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FIREBASE_AUTH, FIRESTORE } from '@core/firebase/firebase.tokens';
import { collectionData$ } from '@core/firebase/firebase-rxjs.utils';
import { SaypStatement } from '@save-as-you-pay/models/sayp-statement.model';

@Injectable({
  providedIn: 'root',
})
export class SaypStatementsService {
  private readonly firestore = inject(FIRESTORE);
  private readonly auth = inject(FIREBASE_AUTH);
  private readonly collectionRef: CollectionReference;

  constructor() {
    this.collectionRef = collection(this.firestore, 'saypStatements');
  }

  streamAllStatements(): Observable<SaypStatement[]> {
    const q = query(this.collectionRef, orderBy('periodStart', 'desc'));
    return collectionData$(q, { idField: 'id' }).pipe(
      map(data => data as unknown as SaypStatement[])
    );
  }

  async markStatementDownloaded(statementId: string): Promise<void> {
    const docRef = doc(this.firestore, 'saypStatements', statementId);
    const currentUser = this.auth.currentUser;

    if (!currentUser) {
      throw new Error(
        'User must be authenticated to mark statement as downloaded'
      );
    }

    await updateDoc(docRef, {
      didDownloadStatements: true,
      lastUpdated: Timestamp.now(),
      lastUpdatedBy: currentUser.uid,
    });
  }
}
